import dynamic from 'next/dynamic';
import { useEffect } from 'react';
import type { BrowseCategorySlug } from '@engage/browse-categories/models';
import { useMembersRouter as useRouter } from '@members/localization/useMembersRouter';

const SchedulePage = dynamic(
  () => import('@members/pg-schedule/components/SchedulePage'),
  {
    ssr: false,
  },
);

export default function ScheduleIndexPage() {
  const router = useRouter();
  const categorySlug = 'all';

  useEffect(() => {
    router.replace('/schedule/all');
  }, []);

  return <SchedulePage categorySlug={categorySlug as BrowseCategorySlug} />;
}
